import VueRouter from 'vue-router';
import routes from './routes';

import url from '../helpers/url';
import i18n from '../i18n';

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (!url.hasLocale(to.fullPath)) {
    return next(`${i18n.locale}${to.fullPath}`);
  }

  return next();
});

export default router;



/** WEBPACK FOOTER **
 ** ./src/router/index.js
 **/